'use strict';

var angular = require('angular');
var StrategyClosureDirective = function StrategyClosureDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/strategy-closure.html'),
    controller: 'StrategyClosureController',
    scope: {
      strategy: '=',
      activeEntityType: '=',
      closeHandler: '&',
      isStatementEmpty: '='
    },
    link: function link(scope, element) {
      element.find('.gdpr-popover').popover();
    }
  };
};
StrategyClosureDirective.$inject = [];
module.exports = StrategyClosureDirective;